import { RoleBasedGuard } from '@classroom-ai/ui/auth/guard';
import { useAuthContext } from '@classroom-ai/ui/auth/hooks';
import { SplashScreen } from '@classroom-ai/ui/components/loading-screen';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

/**
 * Gates the dashboard to STUDENT (and ED360_STAFF) role claims. Renders inside
 * AuthGuard, so the user is already authenticated by the time this runs.
 */
export function StudentGuard({ children }: Props) {
  const { user, loading } = useAuthContext();

  if (loading) {
    return <SplashScreen />;
  }

  return (
    <RoleBasedGuard currentRole={user?.role ?? ''} allowedRoles={['STUDENT', 'ED360_STAFF']} hasContent>
      {children}
    </RoleBasedGuard>
  );
}
